<template>
    <div class="wrap wrap--sub">
        <!-- 헤더 -->
        <main-header />

        <!-- 메인 -->
        <main class="main" role="main">
            <div class="collection-index-container">
                <div class="page-head" v-if="collection">
                    <div class="page-head__inner">
                        <h1 class="page-head__title">{{ product.name }}</h1>
                        <ul class="breadcrumb">
                            <li class="breadcrumb__list" v-for="crumb in crumbs" :key="crumb">{{ crumb }}</li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="page-head">
                    <div class="page-head__inner">
                        <h1 class="page-head__title">JM1001-1</h1>
                        <ul class="breadcrumb">
                            <li class="breadcrumb__list">Home</li>
                            <li class="breadcrumb__list">COLLECTION_3</li>
                            <li class="breadcrumb__list">SAVOY</li>
                            <li class="breadcrumb__list">JM1001-1</li>
                        </ul>
                    </div>
                </div> -->

                <div class="container" v-if="product">
                    <div class="product-item-view--en">
                        <div class="product-item-view--en__header">
                            <div class="product-item-view--en__image-wrap">
                                <div class="product-item-view--en__image">
                                    <vue-magnifier :zoom="product.zoomBasic" :src="[`'/res/shop/products/${product.images[0]}'`]" :src-large="[`'/res/shop/products/${product.images[0]}'`]" />
                                </div>
                            </div>
                            <div class="product-item-view--en__detail">
                                <div class="product-item-view--en__detail-header">
                                    <h3 class="product-item-view--en__detail-tit">{{ product.name }}</h3>
                                    <div class="product-item-view--en__detail-btn-wrap">
                                        <a class="button" :href="`/res/shop/products/${product.images[0]}`" download="">Download</a>
                                    </div>
                                </div>
                                <dl class="product-item-view--en__desc">
                                    <div class="product-item-view--en__desc-items">
                                        <div class="product-item-view--en__desc-item" v-for="(row, index) in details" :key="`detail-row-${index}`">
                                            <template v-if="Array.isArray(row)">
                                                <div v-for="(item, index2) in row" :key="`detail-row-${index}-${index2}`" class="product-item-view--en__desc-item-inner">
                                                    <dt>{{ item.term }}</dt>
                                                    <dd>{{ item.desc }}</dd>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="product-item-view--en__desc-item-inner">
                                                    <dt>{{ row.term }}</dt>
                                                    <dd>{{ row.desc }}</dd>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </dl>
                            </div>
                        </div>
                        <div v-if="relateds.length" class="product-item-view--en__body">
                            <h3 class="product-item-view-subtitle"><strong>BEST MATCH</strong></h3>
                            <div class="product-item-view--en__list">
                                <div class="index-container index-container-en">
                                    <div class="index-wrapper">
                                        <div v-for="({ code, name, thumb }, index) in relateds" :key="`products-${index}`" class="index-items">
                                            <!-- index-slide--selected 클래스 추가 시 스타일 변경됩니다. -->
                                            <a :href="$route.path.replace(productCode, code)" class="index-slide">
                                                <span class="thumbnail" :style="`background-image: url(/res/shop/products/${thumb});`"></span>
                                                <span class="name">{{ name }}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="container">
                    <div class="product-item-view--en">
                        <div class="product-item-view--en__header">
                            <div class="product-item-view--en__image-wrap">
                                <div class="product-item-view--en__image" style="background-image:url(https://www.didwallpaper.com/res/shop/products/65428-1-pattern2.jpg)"></div>
                            </div>
                            <div class="product-item-view--en__detail">
                                <div class="product-item-view--en__detail-header">
                                    <h3 class="product-item-view--en__detail-tit">JM1001-1</h3>
                                    <div class="product-item-view--en__detail-btn-wrap">
                                        <a class="button">Download</a>
                                    </div>
                                </div>
                                <dl class="product-item-view--en__desc">
                                    <div class="product-item-view--en__desc-items">
                                        <div class="product-item-view--en__desc-item">
                                            <dt>Collection</dt>
                                            <dd>SAVOY</dd>
                                        </div>
                                        <div class="product-item-view--en__desc-item">
                                            <dt>Collection</dt>
                                            <dd>SAVOY</dd>
                                        </div>
                                        <div class="product-item-view--en__desc-item">
                                            <dt>Collection</dt>
                                            <dd>SAVOY</dd>
                                        </div>
                                    </div>
                                </dl>
                            </div>
                        </div>
                        <div class="product-item-view--en__body">
                            <h3 class="product-item-view-subtitle"><strong>BEST MATCH</strong></h3>
                            <div class="product-item-view--en__list">
                                <div class="index-container index-container-en">
                                    <div class="index-wrapper">
                                        <div class="index-items">
                                            <div role="button" class="index-slide index-slide--selected">
                                                <span class="thumbnail" style="background-image: url();"></span>
                                                <span class="name">JM1001-1</span>
                                            </div>
                                        </div>
                                        <div class="index-items">
                                            <div role="button" class="index-slide">
                                                <span class="thumbnail" style="background-image: url();"></span>
                                                <span class="name">JM1001-2</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </main>

        <!-- 푸터 -->
        <main-footer />
    </div>
</template>

<script>
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import VueMagnifier from "@/components/plugins/vue-magnifier/vue-magnifier.vue";

export default {
    components: {
        MainHeader,
        MainFooter,
        VueMagnifier,
    },
    data() {
        return {
            collection: null,
            product: null,
            relateds: [],
            productCode: this.$route.params.productCode,
        };
    },
    computed: {
        crumbs() {
            const getParent = (category, parents) => {
                if (category?.parents?.length) {
                    const parent = category.parents[0];
                    return getParent(parent, [parent.name, ...parents]);
                } else return parents;
            };
            return getParent(this.collection, [this.collection.name, this.product.name]);
        },
        details() {
            const { product } = this;
            const width = +product.size?.match(/[0-9].[0-9]+/)[0] * 100;

            return [
                [
                    { term: "Collection", desc: product.category.name },
                    { term: "Dimension", desc: product.size },
                ],
                { term: "Weight", desc: product.weight },
                { term: "Material", desc: product.material },
                [
                    { term: "Repeat", desc: product.repeat?.length ? product.repeat : width ? `${Math.round(width * 3.93700787) / 10}" / ${width.format()}cm` : null },
                    { term: "Match", desc: product.match },
                ],
                [
                    { term: "Color", desc: product.color },
                    { term: "Design", desc: product.design },
                ],
                [
                    { term: "Purpose", desc: product.usage.join(", ") },
                    { term: "Style", desc: product.style.join(", ") },
                ],
                // { term: "Prepasted", desc: product.prepasted },
            ];
        },
        code() {
            return this.$route.params.collectionCode;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                // get category
                var {
                    data: { categories },
                } = await this.$http.get("/api/v1/shop/categories", { params: { code: this.code } });
                this.collection = categories[0];

                const code = this.productCode;

                // get products
                const { products } = await this.$http.get("/api/v1/shop/products", { params: { code } }).then((res) => res.data);
                this.product = products[0];

                // get related
                if (this.product.related) {
                    const { products: relateds } = await this.$http.get("/api/v1/shop/products", { params: { related: this.product.related } }).then((res) => res.data);
                    this.relateds = relateds.filter(({ code: _code }) => _code !== code);
                }
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },
    },
};
</script>
